import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isPresentedWindow } from './presentedWindow';

/**
 * Presenter mode (2026-10-28): a small "Presenter" link back to /admin/presenter on every page of the
 * presenter's OWN window. Shown only when this browser remembers that the signed-in account was let
 * into the presenter dashboard by the server (PRESENTER_SEEN_KEY holds that uid; written by the
 * dashboard chunk after the server check, removed when the server refuses). No read, no call: for
 * everyone else this is one localStorage lookup. Never in a presented window (customers' view), and
 * the link leads only to the server-checked dashboard, so a hand-set key gains nothing.
 */
export const PRESENTER_SEEN_KEY = 'arevina.presenterSeen';

export default function PresenterReturnButton() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (isPresentedWindow || !user || pathname.startsWith('/admin/presenter')) return null;
  let seen: string | null = null;
  try { seen = localStorage.getItem(PRESENTER_SEEN_KEY); } catch { /* storage blocked */ }
  if (seen !== user.uid) return null;
  return (
    <Link
      to="/admin/presenter"
      data-testid="presenter-return"
      className="fixed bottom-4 left-4 z-[1000] rounded-full bg-[var(--rr-red)] px-4 py-2 text-sm font-semibold text-white shadow-lg hover:opacity-90"
    >
      Presenter
    </Link>
  );
}
